module.exports = __webpack_public_path__ + "img/head_guarantee_999.f53c8ee8.png";